import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { action, observable } from 'mobx'
import type { DependentRelationship } from '@taxfyle/txf-api-client'

export type DependentProps = ModelProps<Dependent>

export class Dependent extends Model<Dependent> {
  id = Id.none

  @observable accessor firstName: string | null = null
  @observable accessor middleInitial: string | null = null
  @observable accessor lastName: string | null = null
  @observable accessor tin: string | null = null
  @observable accessor dob: Date | null = null
  @observable accessor relationship: DependentRelationship | null = null
  @observable accessor archived = false

  @action.bound
  archive(): void {
    this.archived = true
  }

  toProps(): DependentProps {
    return {
      id: this.id,
      firstName: this.firstName,
      middleInitial: this.middleInitial,
      lastName: this.lastName,
      tin: this.tin,
      dob: this.dob,
      relationship: this.relationship,
      archived: this.archived,
    }
  }
}
